import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_KEY = "0300337cd5mshf8057d09a0eeaf1p192843jsn01ce35f27c4a";

const baseUrl = "https://wordsapiv1.p.rapidapi.com/words";

const wordsHeader = {
  "x-rapidapi-host": "wordsapiv1.p.rapidapi.com",
  "x-rapidapi-key": API_KEY,
};

const createRequest = (url) => ({ url, headers: wordsHeader });

export const wordsApi = createApi({
  reducerPath: "wordsApi",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getMeaning: builder.query({
      query: (word) => createRequest(`/${word.toLowerCase()}`),
    }),
    getByTypes: builder.query({
      query: ({word, type}) => createRequest(`/${word?.toLowerCase()}/${type}`),
    }),
  }),
});

export const {useGetMeaningQuery,useGetByTypesQuery} = wordsApi;